import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {}

export const IconVariableWorkspace: React.FC<Props> = () => {
  const colors = useStateSelector((state) => state.theme.colors);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
      <path
        d="M5.00098 4.15723C5.14528 4.15723 5.2627 4.27465 5.2627 4.41895V5.51758H7.94238C8.10461 5.51783 8.23633 5.64924 8.23633 5.81152V7.28223H9.70605C9.86849 7.28223 10 7.41374 10 7.57617V10.5176C9.99988 10.6799 9.86841 10.8115 9.70605 10.8115H6.17676C6.0144 10.8115 5.88294 10.6799 5.88281 10.5176V7.57617C5.88281 7.41374 6.01432 7.28223 6.17676 7.28223H7.64746V6.10547H2.35352V7.28223H3.82324C3.98568 7.28223 4.11719 7.41374 4.11719 7.57617V10.5176C4.11706 10.6799 3.9856 10.8115 3.82324 10.8115H0.293945C0.131585 10.8115 0.000124117 10.6799 0 10.5176V7.57617C0 7.41374 0.131509 7.28223 0.293945 7.28223H1.76562V5.81152C1.76562 5.64909 1.89713 5.51758 2.05957 5.51758H4.73926V4.41895C4.73926 4.27465 4.85668 4.15723 5.00098 4.15723ZM0.587891 10.2236H3.5293V7.87012H0.587891V10.2236ZM6.4707 10.2236H9.41211V7.87012H6.4707V10.2236ZM3.82031 3.23145L4.73828 0H5.29688L6.1709 3.2207L7.00781 0H7.54395L6.43945 3.81152H5.88184L4.99609 0.744141L4.07715 3.81152L3.52441 3.81738L2.45801 0H2.98926L3.82031 3.23145Z"
        fill="url(#paint0_linear_13088_17270)"
      />
      <defs>
        <linearGradient id="paint0_linear_13088_17270" x1="5" y1="0" x2="5" y2="10.8115" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
